import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { parse } from 'query-string'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import * as App from '../../../app'
import * as IsActive from '../../../components/is_active'
import * as Menu from '../../../components/menu'
import * as Request from '../../../request'
import { ApplicationState } from '../../../rootReducer'
import * as Router from '../../../router'
import * as Actions from './actions'
import * as Constants from './constants'
import { convertSelectedDateToDateString } from './utils'

type Reducer = ReduxObservable.Epic<Redux.Action, any>
const onEnter: Reducer = (action$, store, {history}) =>
  action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname === Menu.REPORTS_DAILY_URL)
  .map(store.getState)
  .filter((state) => !isEmpty(state.app.selectedCommunity))
  .filter((state) => isEmpty(state.reports.today.issues))
  .filter((state) => !state.reports.today.view.isLoading)
  .mergeMap((state: App.WrappedState) => [
    Actions.updateSelectedDate(get(state.app.urlParams, 'selectedDate')),
    Actions.fetchIssues(
      state.app.selectedCommunity, get(state.app.urlParams, 'selectedDate')),
  ])

const getEvents: Reducer = (action$, store, {history}) =>
  action$.ofType(Request.successConstant(Constants.FETCH_TODAY_ISSUES))
    .filter(() => history.location.pathname === Menu.REPORTS_DAILY_URL)
    .map(store.getState)
    .filter((state) => !isEmpty(state.reports.today.issues))
    .mergeMap((state) => [
      Actions.fetchActions(state.app.selectedCommunity, state.reports.today.issues),
      Actions.fetchSubjectLines(state.app.selectedCommunity, state.reports.today.issues),
    ])

const onDateChange: Reducer = (action$, store, {history}) =>
  action$.ofType(Constants.SELECT_TODAY_DATE)
  .filter(() => history.location.pathname === Menu.REPORTS_DAILY_URL)
  .map(store.getState)
  .filter((state) => !isEmpty(state.reports.today.view.selectedDate))
  .mergeMap((state) => [
    App.updateUrlParams({
      selectedDate: state.reports.today.view.selectedDate,
    }),
    Actions.fetchIssues(
      state.app.selectedCommunity,
      state.reports.today.view.selectedDate),
    ])

const updateUrl: ReduxObservable.Epic<any, any> = (
    action$,
    store: Redux.Store<ApplicationState>,
    {history}: App.Dependencies) =>
  action$.ofType(Constants.UPDATE_SELECTED_DATE)
    .filter(() => history.location.pathname.startsWith(Menu.REPORTS_DAILY_URL))
    .mergeMap((action) => [
      App.updateUrlParams({dateSelect: null, selectedDate: action.date}),
      Actions.fetchIssues(
        store.getState().app.selectedCommunity,
        convertSelectedDateToDateString(null, action.date))])

const initialLoad = (
    action$: ReduxObservable.ActionsObservable<Redux.Action>,
    store: Redux.Store<ApplicationState>,
    {history}: App.Dependencies) =>
  action$.ofType(Router.ON_ENTER)
    .filter(() => history.location.pathname.startsWith(Menu.REPORTS_DAILY_URL))
    .map(() => parse(history.location.search))
    .map((searchParams) =>
      Actions.fetchIssues(
          store.getState().app.selectedCommunity,
          convertSelectedDateToDateString(searchParams.dateSelect, searchParams.selectedDate)))

const dropDownUpdate: ReduxObservable.Epic<any, any> = (
    action$,
    store: Redux.Store<ApplicationState>,
    {history}: App.Dependencies) =>
  action$.ofType(IsActive.filterStatusConstant(Constants.CHANGE_DATE_SELECT))
    .filter(() => history.location.pathname.startsWith(Menu.REPORTS_DAILY_URL))
    .filter((action) => action.filter.value !== Constants.DATE_SELECT_CUSTOM_MODE)
    .mergeMap((action) => [
      App.updateUrlParams({dateSelect: action.filter.value, selectedDate: null}),
      Actions.fetchIssues(
        store.getState().app.selectedCommunity,
        convertSelectedDateToDateString(action.filter.value, null)),
      ])

export const epic = ReduxObservable.combineEpics(
  initialLoad,
  updateUrl,
  dropDownUpdate,
  onDateChange,
  getEvents,
  onEnter,
)



// WEBPACK FOOTER //
// ./src/pages/reports/today/epic.ts